'use strict';

module Patersons {

    export interface CallbackScope extends ng.IScope {
        events: any;

    }

    export class CallbackCtrl {

        scope: Patersons.CallbackScope;
        location: angular.ILocationService;
        window: ng.IWindowService;
        http: ng.IHttpService;
        tokenService: TokenService;
        identityService: IdentityService;
        state: angular.ui.IStateService;
        $analytics; 

        static $inject = ['$scope', '$location', '$window', '$state', '$http', 'tokenService', 'applicationInsightsService', 'identityService', '$analytics'];

        constructor($scope, $location, $window, $state, $http, tokenService, applicationInsightsService, identityService, $analytics) {
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.http = $http;
            this.tokenService = tokenService;
            this.identityService = identityService;
            this.state = $state;
            this.$analytics = $analytics
            var url: string = this.location.url();

            var querystring = url.substring(url.lastIndexOf('#'), url.length);
            this.scope.events = this;
            console.log(querystring);
            var promise = this.tokenService.tokenManager.processTokenCallbackAsync(querystring);

            promise.then(value => {

                // The following sets the unique id for app insights to the sub
                var uuidKey = "$$appInsights__uuid";
                var uuid = applicationInsightsService._localStorage.get(uuidKey);
                if (uuid != tokenService.tokenManager.profile.sub) {
                    var uuid = applicationInsightsService._localStorage.set(uuidKey, tokenService.tokenManager.profile.sub);
                }

                $scope.events.navigateOnSuccess();
            },
                (reason) => {
                    alert('An error has occurred: ' + (reason && reason.message || "Unknown error"));
                    this.tokenService.tokenManager.removeToken();
                    //this.tokenService.tokenManager.redirectForLogout();
                    window.location = "/identity/connect/endsession" as any;
                });
        }

        navigateOnSuccess() {
            var redirect_to = '/dashboard';
            var redirect_uri = window.localStorage.getItem('$psl.redirect_uri');
            if (redirect_uri) {
                window.localStorage.removeItem('$psl.redirect_uri');
                if(redirect_uri.indexOf("confirmPassword") === -1){
                    redirect_to = redirect_uri;
                }
            }
            if (this.tokenService.tokenManager.profile) {
                var profile = this.tokenService.tokenManager.profile;
                
                //let prefs: UserPreferences = UserPreferences.load(profile.preferred_username);
                this.$analytics.setUsername(profile.preferred_username);

                var trackLoginSuccess = function(callback){
                    if(window['google_tag_manager']){
                        var dataLayer = window["dataLayer"] || [];
                         dataLayer.push({
                            'event': 'interaction',
                            'target': 'Login',
                            'action': 'Login Success',
                            'userId': profile.preferred_username,
                            'eventCallback' : () => {
                                callback()
                            },
                            'eventTimeout' : 1500
                        });
                    }else{
                        callback()
                    }
                }
                trackLoginSuccess(() => {
                    this.identityService.getSkipMobileRegistration().
                    then((skipMobile) => {
                      if (skipMobile === true) {
                          console.log(skipMobile);
                          this.window.location.href = redirect_to;
                          return false;
                      } else {
                        // check if phone number is verifyed
                        this.identityService.getIsPhoneNumberVerifyed().
                        then((phone_number_verified: boolean) => {
                          // if phone is veryfied
                          if (phone_number_verified === true){
                              console.log(profile);
                              // go to dashboard
                              this.window.location.href = redirect_to;
                              return false;
                          }
                          else {
                              // else
                              this.identityService.saveSkipMobileRegistration(new SkipMobileDetails()).
                              then(() => {
                                this.window.location.href = '/registerMobile';
                              }).
                              catch(() => {
                                this.window.location.href = '/registerMobile';
                              });
                          }
                        });
                      }
                    }).
                    catch(response => {
                      this.window.location.href = redirect_to;
                      return false;
                    });
                })
            } else {
                this.window.location.href = redirect_to;
                return false;
            }
        }
    }
}
